<template>
    <div class="contenedor_modal_completo">
        <div class="contenedor_modal_completo_cabecera">
            <button type="button" class="btn btn-sm btn-outline-danger" @click="cerrar">Cerrar</button>
        </div>
        <div class="contenedor_modal_completo_contenido">
            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <h2>
                            Permisos
                        </h2>
                    </div>
                    <div class="col-sm-12 mt-1">
                        Nombre: {{ usuario_seleccionado_permisos.nombre_completo }} {{ datos_usuario.id ==
                            usuario_seleccionado_permisos.id ? '(Yo)' : '' }} <br> Usuario:
                        {{ usuario_seleccionado_permisos.username }} <br> ID:
                        {{ usuario_seleccionado_permisos.id }}
                    </div>
                    <div class="col-sm-12 mt-3">
                        <label for="" class="form-label">Empresa</label>
                        <select class="form-control form-control-sm" v-model="empresa_"
                            @change="obtener_permisos_segun_este_usuario">
                            <option value="">Seleccionar</option>
                            <option v-for="(item, index) in empresas_por_usuario" :key="index"
                                :value="item.codigo_empresa">{{ item.nombre_empresa }}
                            </option>
                        </select>
                    </div>

                    <div class="col-sm-12 mt-3">
                        <div class="marco_permisos">

                            <table class="table table-sm table-striped table-bordered sticky-table"
                                style="font-size: 13px;">
                                <thead class="sticky-header_">
                                    <tr>
                                        <th style="width: 50%;">
                                            MÓDULO
                                        </th>
                                        <th style="width: 10%;text-align: center;"
                                            @dblclick="activarTodosPermisos('ver')">
                                            VER
                                        </th>
                                        <th style="width: 10%;text-align: center;"
                                            @dblclick="activarTodosPermisos('crear')">
                                            CREAR
                                        </th>
                                        <th style="width: 10%;text-align: center;"
                                            @dblclick="activarTodosPermisos('leer')">
                                            LEER
                                        </th>
                                        <th style="width: 10%;text-align: center;"
                                            @dblclick="activarTodosPermisos('actualizar')">
                                            ACTUALIZAR
                                        </th>
                                        <th style="width: 10%;text-align: center;"
                                            @dblclick="activarTodosPermisos('eliminar')">
                                            ELIMINAR
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in modulos_ordenados" :key="index">
                                        <td>
                                            {{ item | nombre_perfil }}
                                        </td>
                                        <td>
                                            <div style="text-align: center;">
                                                <input type="checkbox" :checked="permisos[item] && permisos[item].ver"
                                                    @click="actualizar_permisos({ item, accion: 'ver' })">
                                            </div>
                                        </td>
                                        <td>
                                            <div style="text-align: center;">
                                                <input type="checkbox" :checked="permisos[item] && permisos[item].crear"
                                                    @click="actualizar_permisos({ item, accion: 'crear' })">
                                            </div>
                                        </td>
                                        <td>
                                            <div style="text-align: center;">
                                                <input type="checkbox" :checked="permisos[item] && permisos[item].leer"
                                                    @click="actualizar_permisos({ item, accion: 'leer' })">
                                            </div>
                                        </td>
                                        <td>
                                            <div style="text-align: center;">
                                                <input type="checkbox"
                                                    :checked="permisos[item] && permisos[item].actualizar"
                                                    @click="actualizar_permisos({ item, accion: 'actualizar' })">
                                            </div>
                                        </td>
                                        <td>
                                            <div style="text-align: center;">
                                                <input type="checkbox"
                                                    :checked="permisos[item] && permisos[item].borrar"
                                                    @click="actualizar_permisos({ item, accion: 'eliminar' })">
                                            </div>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
    import {
        mapActions,
        mapState
    } from 'vuex';

    export default {
        name: 'ModalPermisos',
        filters: {
            nombre_perfil: function (val) {
                return val.replace(/\./g, " -> ").replace(/_/g, " ").toUpperCase()
            }
        },
        computed: {
            ...mapState(['usuario_seleccionado_permisos', 'datos_usuario', 'empresas_por_usuario'])
        },
        data() {
            return {
                perfil_permisos: '',
                id_perfil_permiso: '',
                ver: 0,
                crear: 0,
                leer: 0,
                actualizar: 0,
                eliminar: 0,
                empresa_: '',
                modulos: [
                    'inventarios',
                    'inventarios.busqueda',
                    'inventarios.busqueda.precio_costo',
                    'inventarios.busqueda.actualizar_precios',
                    'inventarios.busqueda.movimientos',
                    'inventarios.busqueda.crear_articulo',
                    'inventarios.reportes',
                    'inventarios.reportes.corte_caja',
                    'inventarios.reportes.bitacora',
                    'inventarios.reportes.consolidado',
                    'inventarios.reportes.por_producto',
                    'inventarios.reportes.por_vendedor',
                    'inventarios.reportes.por_promocion',
                    'inventarios.reportes.por_vendedor_producto',
                    'inventarios.rayo',
                    'inventarios.rayo.medidas',
                    'inventarios.rayo.materiales',
                    'inventarios.rayo.promociones',
                    'inventarios.rayo.maquinas',
                    'inventarios.rayo.rollos',
                    'inventarios.rayo.sobres',
                    'inventarios.movimientos',
                    'inventarios.movimientos.entradas',
                    'inventarios.movimientos.salidas',
                    'inventarios.movimientos.salidas.motivos',
                    'inventarios.movimientos.entradas.motivos',
                    'traslados',
                    'sucursales',
                    'sucursales.productos',
                    'sucursales.usuarios',
                    'marcas',
                    'proveedores',
                    'registro_desperdicio',
                    'registro_desperdicio.reporte',
                    'solicitud_descuento',
                    'solicitud_descuento.pendientes',
                    'solicitud_descuento.aprobadas',
                    'solicitud_descuento.rechazadas',
                    'anulacion_de_factura',
                    'solicitudes_de_anulacion',
                    'configuracion',
                    'facturador',
                    'depositos',
                    'depositos.registros',
                    'depositos.registros.congelar',
                    'depositos.consulta',
                    'anticipos',

                ],
                modulos_ordenados: [],
                permisos: {}

            }
        },
        methods: {
            async cerrar() {
                this.$emit('salir')
            },
            async selector_perfil_permisos() {
                if (this.perfil_permisos != '') {
                    let r = this.permisos[this.perfil_permisos]
                    this.id_perfil_permiso = r.document_id
                    this.ver = r.ver == false ? 0 : 1
                    this.crear = r.crear == false ? 0 : 1
                    this.leer = r.leer == false ? 0 : 1
                    this.actualizar = r.actualizar == false ? 0 : 1
                    this.eliminar = r.borrar == false ? 0 : 1
                }

            },
            async actualizar_permisos(datos) {
                const modulo = datos.item;
                const accion = datos.accion;
                const pp = this.permisos[modulo]
                const ppid = pp.document_id

                // Si no existe el permiso para este módulo, lo inicializamos
                if (!this.permisos[modulo]) {
                    this.$set(this.permisos, modulo, {
                        ver: false,
                        crear: false,
                        leer: false,
                        actualizar: false,
                        borrar: false,
                        document_id: ppid
                    });
                }

                // Invertimos el valor actual del permiso
                const valorActual = this.permisos[modulo][accion === 'eliminar' ? 'borrar' : accion];
                this.$set(this.permisos[modulo], accion === 'eliminar' ? 'borrar' : accion, !valorActual);

                // Preparamos los datos para enviar al servidor
                let f = {
                    api: `permisos/a/actualizar?did=${this.permisos[modulo].document_id || ''}&empresa=${this.empresa_}`,
                    formulario: {
                        modulo,
                        ver: this.permisos[modulo].ver,
                        crear: this.permisos[modulo].crear,
                        leer: this.permisos[modulo].leer,
                        actualizar: this.permisos[modulo].actualizar,
                        borrar: this.permisos[modulo].borrar,
                    }
                }


                // Descomentar estas líneas cuando estés listo para guardar los cambios
                await this.actualizar_data(f)
                await this.obtener_permisos_segun_este_usuario()
            },
            orden_alfabetico_modulos() {
                this.modulos_ordenados = this.modulos.sort()
            },
            async activarTodosPermisos(accion) {
                // Determinar el estado actual de la mayoría de los checkboxes para decidir si activar o desactivar todos
                let contadorActivos = 0;
                let total = this.modulos_ordenados.length;

                // Contar cuántos están activos actualmente
                for (const modulo of this.modulos_ordenados) {
                    if (this.permisos[modulo] && this.permisos[modulo][accion === 'eliminar' ? 'borrar' : accion]) {
                        contadorActivos++;
                    }
                }

                // Si más de la mitad están activos, desactivamos todos, de lo contrario, activamos todos
                const nuevoEstado = contadorActivos < total / 2;

                let f = {
                    api: `permisos/a/actualizar_por_fila?usuario=${this.usuario_seleccionado_permisos.id}&empresa=${this.empresa_}`,
                    formulario: {
                        estado: nuevoEstado,
                        accion
                    }
                }

                await this.actualizar_data(f)
                await this.obtener_permisos_segun_este_usuario()
            },
            async obtener_permisos_segun_este_usuario() {
                let f = {
                    api: `permisos/c/obtener?empresa=${this.empresa_}&id_usuario=${this.usuario_seleccionado_permisos.id}`,
                }

                let r = await this.obtener_data(f)
                this.orden_alfabetico_modulos()
                this.permisos = r
            },
            ...mapActions(['actualizar_data', 'obtener_empresas_por_usuario', 'obtener_data'])
        },
        async mounted() {
            await this.selector_perfil_permisos()
            // await this.orden_alfabetico_modulos()
            await this.obtener_empresas_por_usuario()
        },
    }
</script>

<style>
    .marco_permisos {
        width: 100%;
        height: calc(100vh - 300px);
        overflow: auto;
        position: relative;
    }

    .sticky-table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .sticky-header_ {
        position: sticky;
        top: 0;
        z-index: 1;
        background-color: #fff;
    }

    .sticky-header_ th {
        background-color: #fff;
        /* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1); */
    }

    th {
        cursor: pointer;
        user-select: none;
    }

    th:hover {
        background-color: rgba(0, 0, 0, 0.05);
    }
</style>
